'use client';

import { useState } from 'react';
import Image from 'next/image';
import LightboxGallery from '@/components/LightboxGallery';
import siteTheme from '@/lib/theme';

const { fonts } = siteTheme;

export default function GalleryGridClient({ images, roomName }: { images: string[]; roomName: string }) {
  const [lightboxIndex, setLightboxIndex] = useState<number | null>(null);
  const lbImages = images.map(url => ({ url }));
  const show = images.slice(1, 5);
  const extra = Math.max(0, images.length - 5);

  return (
    <>
      <div style={{ display: 'grid', gridTemplateColumns: 'repeat(4, 1fr)', gap: '0.5rem' }}>
        {show.map((src, i) => {
          const isLast = i === show.length - 1 && extra > 0;
          const globalIndex = i + 1;
          return (
            <button
              key={i}
              onClick={() => setLightboxIndex(globalIndex)}
              className="group"
              style={{
                position: 'relative', aspectRatio: '1/1.5', borderRadius: '0.8rem',
                overflow: 'hidden', border: '1px solid rgba(13,47,68,0.07)',
                padding: 0, cursor: 'pointer', display: 'block', width: '100%',
              }}
            >
              <Image
                src={src}
                alt={i === 0 ? roomName : ''}
                fill
                sizes="12vw"
                className="object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {isLast && (
                <div style={{
                  position: 'absolute', inset: 0, background: 'rgba(0,0,0,0.52)',
                  display: 'flex', flexDirection: 'column', alignItems: 'center',
                  justifyContent: 'center', gap: '0.3rem', pointerEvents: 'none',
                }}>
                  <span style={{ fontFamily: fonts.serif, fontSize: '2rem', fontWeight: 300, color: '#fff', lineHeight: 1 }}>+{extra}</span>
                  <span style={{ fontFamily: fonts.sans, fontSize: '1rem', color: 'rgba(255,255,255,0.85)', letterSpacing: '0.1em', textTransform: 'uppercase' }}>View all photos</span>
                </div>
              )}
            </button>
          );
        })}
      </div>

      {lightboxIndex !== null && (
        <LightboxGallery
          images={lbImages}
          startIndex={lightboxIndex}
          onClose={() => setLightboxIndex(null)}
        />
      )}
    </>
  );
}
